import { IPendingSsnRepository } from '../ports/outbound/IPendingSsnRepository';
import { PendingSsnResult } from '../domain/entities/PendingSsnResult';
import { SortOrder } from "@/shared/application/domain/enums/SortOrder";

export class FetchPendingSsnRecords {
  constructor(private repository: IPendingSsnRepository) {}

  async execute(
    page: number,
    pageSize: number,
    columnName?: string,
    sortOrder?: SortOrder
  ): Promise<PendingSsnResult> {
    return this.repository.fetchPendingSsnRecords(page, pageSize, columnName, sortOrder);
  }

  async submitSsn(i9FormId: string, ssn: string): Promise<void> {
    return this.repository.submitSsn(i9FormId, ssn);
  }

  async sendEmailReminder(
    email: string,
    i9FormId: string
  ): Promise<void> {
    return this.repository.sendEmailReminder(email, i9FormId);
  }
}
